<template>
  <div class="d-warp">
    <div
      class="main"
      :style="
        'background: url(' +
          detail.background_img +
          ') no-repeat top center #2d127d; background-size:100% auto;'
      "
    >
      <div
        class="title-warp"
        :style="
          'width:' +
            680 * baseSize +
            'px;padding-top:' +
            0 +
            'px; margin-bottom:' +
            40 * baseSize +
            'px'
        "
      >
        <img :src="detail.brief_img" />
      </div>
      <slot></slot>
    </div>
    <Form v-if="prizeForm" />
    <div class="loading" @touchmove="showLoading=false" v-show="showLoading">
      <Loading bgColor="#0075ff" :loading="showLoading" />
    </div>
  </div>
</template>

<script>
import { baseOssUrl } from "@/util/config";
import Loading from "@/components/Loading.vue";
import Form from "@/components/LuckDraw/Form.vue";
const clientWidth =
  window.innerWidth ||
  document.body.clientWidth ||
  document.documentElement.clientWidth;
const baseSize = .85 * (clientWidth > 640 ? 1 : clientWidth / 640);
export default {
  props: {
    detail: {
      type: Object,
      default: {},
    },
    showLoading: {
      type: Boolean,
      default: false
    }
  },
  components:{
    Loading,
    Form
  },
  watch: {
    detail: {
      handler(newVal) {
        console.log(newVal);
      },
      deep: true,
      immediate: true
    },
    // prizeForm(){

    // }
  },
  data() {
    return {
      baseOssUrl,
      baseSize,
    };
  },
  computed: {
    prizeForm() {
      return this.$store.state.showPrizeForm;
    },
  },
  methods: {}
};
</script>

<style scoped lang="scss">
img {
  display: block;
  max-width: 100%;
}

.d-warp {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  .main {
    width: 100%;
    min-height: 100vh;
    position: relative;
    z-index: 665;
    .title-warp {
      margin: 0 auto;
    }
  }
}
.loading{position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.2);
  z-index: 666;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/LuckDraw/Base.vue